// datadog web logging
import _ from 'lodash';
import config from './config';

const PII_FIELDS_BLACKLIST = [
  'firstName',
  'lastName',
  'phoneNumber',
];

/* eslint-disable */
const DDLogs = {
  init() {
    DD_LOGS.init({
      publicApiKey: config.get().datadogPublicApiKey,
      forwardErrorsToLogs: true,
      site: 'datadoghq.com',
    });
    this.addGlobalContext('service' ,'anna');
  },

  addGlobalContext(ctxName, ctxValue) {
    DD_LOGS.addLoggerGlobalContext(ctxName, ctxValue);
  },

  log(message, data) {
    const dataWithoutPII = _.pickBy(data, (value, key) => !_.includes(PII_FIELDS_BLACKLIST, key));
    DD_LOGS.logger.log(message, dataWithoutPII);
  },

  error(message, data) {
    const dataWithoutPII = _.pickBy(data, (value, key) => !_.includes(PII_FIELDS_BLACKLIST, key));
    DD_LOGS.logger.error(message, dataWithoutPII);
  },
};

export default DDLogs;
